import React, { Component, useEffect, useState } from "react";
import ComponentInvoiceMobile from "./ComponentInvoiceCreditPayment";
import ComponentInvoiceWeb from "./ComponentInvoiceCreditPaymentDesktop";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentInvoiceCreditPayment = () => {
  const gaEventTracker = useAnalyticsEventTracker("Invoice");
  useEffect(() => {
    console.log("ComponentInvoiceCreditPayment mounted");

    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Invoice",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentInvoiceWeb></ComponentInvoiceWeb>
      </BrowserView>
      <MobileView>
        <ComponentInvoiceMobile></ComponentInvoiceMobile>
      </MobileView>
    </>
  );
};
export default ComponentInvoiceCreditPayment;
